import React from "react";
import { Link } from "react-router-dom";
import AuthService from "../../service/AuthService";
import { AccountCircle, Logout, Help } from "@mui/icons-material"
import CheckIcon from "@mui/icons-material/Check";
import Profile from "../user/Profile";
import { DialogWidget } from "../../Widget"
import { Box, Button, IconButton, Menu, MenuItem, Tooltip, Typography } from "@mui/material"
import { makeStyles } from '@mui/styles';
import { util } from "../../commons";
import PasswordChange from "../user/PasswordChange";
import { customStyles } from "../../styles/tableStyle";

const useStyles = makeStyles(theme => ({
    root: {
        flexGrow: 1
    },
    menuButton: {
        marginRight: theme.spacing(2)
    },
    title: {
        flexGrow: 1
    }
}));



export default function AccountActions() {
    const classes = useStyles();
    const [dialogStatus, setDialogStatus] = React.useState(false);
    const [dialogType, setDialogType] = React.useState('');
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);

    const openMenu = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const closeMenu = () => {
        setAnchorEl(null);
    };

    const handleDialogClose = () => {
        setDialogStatus(false)
        setDialogType("")
    }

    const handleDialog = (e, key) => {
        setAnchorEl(null);
        setDialogStatus(true)
        setDialogType(key)
    };

    const logOutUser = () => {
        localStorage.setItem("login", false);
        localStorage.clear();
        setDialogStatus(false)
        window.location.href = '/login';

    }



    return (
        <div style={{ display: 'flex', flexDirection: 'column', alignSelf: 'center' }}>
            <Box sx={{ alignSelf: 'center' }} flexDirection={'row'} display={'flex'}>
                <Typography sx={customStyles.actionIcon}>{AuthService.getUserInfo() && util.titleCase(AuthService.getUserInfo().name)}</Typography>
                <Tooltip title={"Help"}>
                    <Help sx={customStyles.actionIcon} onClick={e => handleDialog(e, "userManual")} />
                </Tooltip>
                <Tooltip title={"Profile Settings"}>
                    <AccountCircle sx={customStyles.actionIcon} onClick={openMenu}>
                    </AccountCircle>
                </Tooltip>
                <Menu
                    id="basic-menu"
                    anchorEl={anchorEl}
                    open={open}
                    onClose={closeMenu}
                    MenuListProps={{
                        'aria-labelledby': 'basic-button',
                    }}
                >
                    <MenuItem onClick={e => handleDialog(e, "profile")}>Profile</MenuItem>
                    <MenuItem onClick={e => handleDialog(e, "passwordChange")}>Password Change</MenuItem>
                </Menu>

                <Tooltip title={"Logout"}>
                    <Logout sx={customStyles.actionIcon} onClick={e => handleDialog(e, "logout")} />
                </Tooltip>


            </Box>
            {dialogStatus && dialogType === "logout" ?
                <DialogWidget
                    maxWidth="xs"
                    dialogTitle={"Confirm Logout"}
                    okTitle={"Logout"}
                    negOk={true}
                    cancelTitle={"Continue Session"}
                    dialogContent={"Are you sure you want to logout from RegMagic ?"}
                    okDialog={logOutUser}
                    closeDialog={handleDialogClose}
                /> : false}

            {dialogStatus && dialogType === "passwordChange" ?
                <DialogWidget
                    maxWidth="sm"
                    dialogTitle={"Change Password"}
                    okTitle={"Submit"}
                    negOk={false}
                    dialogContent={<PasswordChange type="self" closeDialog={handleDialogClose} />}
                /> : false}

            {dialogStatus && dialogType === "profile" ?
                <DialogWidget
                    maxWidth="sm"
                    dialogTitle={"Profile"}
                    okTitle={"Submit"}
                    negOk={false}
                    dialogContent={<Profile type="self" closeDialog={handleDialogClose} />}
                /> : false}

            {dialogStatus && dialogType === "userManual" ?
                <DialogWidget
                    maxWidth="lg"
                    dialogTitle={"User Manual"}
                    cancelTitle={"Close"}
                    closeDialog={handleDialogClose}
                    negOk={false}
                    dialogContent={
                        <iframe
                            src={"https://cad.proxelera.com/Reg%20Magic%20User%20Manual.pdf"}
                            title="PDF Viewer"
                            width="100%"
                            height="500px"
                            style={{ border: "none" }}
                        />
                    }
                /> : false}

        </div>
    );
}
